import React from 'react'
import CustomTimeTick from './charts/CustomTimeTick'
import PercentageTick from './charts/PercentageTick'
import CurrencyTick from 'widgets/charts/CurrencyTick'
import CompactNumberTick from 'widgets/charts/CompactNumberTick'
import NumberTick from 'widgets/charts/NumberTick'

export default function DynamicTick (props) {
  const getTickComponent = () => {
    switch (props.type) {
      case 'time':
        return <CustomTimeTick />
      case 'percentage':
        return <PercentageTick />
      case 'currency':
        return <CurrencyTick />
      case 'compact_number':
        return <CompactNumberTick />
      case 'number':
        return <NumberTick />
      default:
        return <CustomTimeTick />
    }
  }

  const tickComponent = getTickComponent()

  if (React.isValidElement(tickComponent)) {
    return React.cloneElement(tickComponent, props)
  }

  return null
}
